module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Oprah Winfrey"), _c('br'), _vm._v("You are the epitome of what an"), _c('br'), _vm._v("entrepreneur should be.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("Thank you for going after what you"), _c('br'), _vm._v("want with class and vigor.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("You inspire me to reach for greatness"), _c('br'), _vm._v("and OWN my choices.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("The icing you put of the cake of your"), _c('br'), _vm._v("life motivates many to strive to be"), _c('br'), _vm._v("stellar.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("May all who reads this series be the"), _c('br'), _vm._v("cream of the crop too.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("You are amazing. I am so grateful for"), _c('br'), _vm._v("your example … you shine!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 66
// module chunks = 0